export function getDistinctRetailers(lineItems) {
    return lineItems
        .map(item => item.retailer)
        .filter(Boolean)
        .filter((value, index, self) => self.findIndex(r => r['@id'] === value['@id']) === index);
}
